import lazyScreen from '../utils/lazyScreen';
const ARInvoicables = lazyScreen(() => import('../pages/tax/ARInvoicables/index.js'), 'pages/tax/ARInvoicables/index.js');
const APInvoicables = lazyScreen(() => import('../pages/tax/APInvoicables/index.js'), 'pages/tax/APInvoicables/index.js');
const EXPInvoicables = lazyScreen(() => import('../pages/tax/EXPInvoicables/index.js'), 'pages/tax/EXPInvoicables/index.js');
const EXRInvoicables = lazyScreen(() => import('../pages/tax/EXRInvoicables/index.js'), 'pages/tax/EXRInvoicables/index.js');
const TaxInvoices = lazyScreen(() => import('../pages/tax/Invoices/index.js'), 'pages/tax/Invoices/index.js');
const TaxSaleInvoicables = lazyScreen(() => import('../pages/tax/SaleInvoicables/index.js'), 'pages/tax/SaleInvoicables/index.js');
const TaxPurchaseInvoicables = lazyScreen(() => import('../pages/tax/PurchaseInvoicables/index.js'), 'pages/tax/PurchaseInvoicables/index.js');
const EInvoiceLogs = lazyScreen(() => import('../pages/tax/EInvoiceLogs/index.js'), 'pages/tax/EInvoiceLogs/index.js');
const TaxBooks = lazyScreen(() => import('../pages/tax/TaxBooks/index.js'), 'pages/tax/TaxBooks/index.js');
const InvoiceAdjustments = lazyScreen(() => import('../pages/tax/InvoiceAdjustments/index.js'), 'pages/tax/InvoiceAdjustments/index.js');
const VATInputReports = lazyScreen(() => import('../pages/tax/VATInputReports/index.js'), 'pages/tax/VATInputReports/index.js');
const VATOutputReports = lazyScreen(() => import('../pages/tax/VATOutputReports/index.js'), 'pages/tax/VATOutputReports/index.js');
const VATDeclarations = lazyScreen(() => import('../pages/tax/VATDeclarations/index.js'), 'pages/tax/VATDeclarations/index.js');
const VATDeclaration = lazyScreen(() => import('../pages/tax/VATDeclaration/index.js'), 'pages/tax/VATDeclaration/index.js');
const ARInvoices = lazyScreen(() => import('../pages/ar/ARInvoices/index.js'), 'pages/ar/ARInvoices/index.js');
const APInvoices = lazyScreen(() => import('../pages/ap/APInvoices/index.js'), 'pages/ap/APInvoices/index.js');
const EXPInvoices = lazyScreen(() => import('../pages/exp/EXPInvoices/index.js'), 'pages/exp/EXPInvoices/index.js');
const EXRInvoices = lazyScreen(() => import('../pages/exr/EXRInvoices/index.js'), 'pages/exr/EXRInvoices/index.js');

const PITAnnuals = lazyScreen(() => import('../pages/tax/PITAnnuals/index.js'), 'pages/tax/PITAnnuals/index.js');
const PITAnnual = lazyScreen(() => import('../pages/tax/PITAnnual/index.js'), 'pages/tax/PITAnnual/index.js');
const CITCalculations = lazyScreen(() => import('../pages/tax/CITCalculations/index.js'), 'pages/tax/CITCalculations/index.js');
const CITCalculation = lazyScreen(() => import('../pages/tax/CITCalculation/index.js'), 'pages/tax/CITCalculation/index.js');

export default [
    {
        path: '/tax/ARInvoicables',
        component: ARInvoicables
    },
    {
        path: '/tax/APInvoicables',
        component: APInvoicables
    },
    {
        path: '/tax/EXPInvoicables',
        component: EXPInvoicables
    },
    {
        path: '/tax/EXRInvoicables',
        component: EXRInvoicables
    },
    {
        path: '/tax/SaleInvoicables',
        component: TaxSaleInvoicables
    },
    {
        path: '/tax/PurchaseInvoicables',
        component: TaxPurchaseInvoicables
    },
    {
        path: '/tax/Invoices',
        component: TaxInvoices
    },
    {
        path: '/tax/ARInvoices',
        component: ARInvoices
    },
    {
        path: '/tax/APInvoices',
        component: APInvoices
    },
    {
        path: '/tax/EXPInvoices',
        component: EXPInvoices
    },
    {
        path: '/tax/EXRInvoices',
        component: EXRInvoices
    },
    {
        path: '/tax/EInvoiceLogs',
        component: EInvoiceLogs
    },
    {
        path: '/tax/TaxBooks',
        component: TaxBooks
    },
    {
        path: '/tax/InvoiceAdjustments',
        component: InvoiceAdjustments
    },
    {
        path: '/tax/VATInputReports',
        component: VATInputReports
    },
    {
        path: '/tax/VATOutputReports',
        component: VATOutputReports
    },
    {
        path: '/tax/VATDeclarations',
        component: VATDeclarations
    },
    {
        path: '/tax/VATDeclaration/:code',
        component: VATDeclaration
    },
    { path: '/tax/PITAnnuals', component: PITAnnuals },
    { path: '/tax/PITAnnual/:code', component: PITAnnual },
    { path: '/tax/CITCalculations', component: CITCalculations },
    { path: '/tax/CITCalculation/:code', component: CITCalculation }
];
